import { makeAutoObservable, runInAction } from 'mobx';
import apiService from 'Service';

class SettingsStore {
    isLoading = false
    isSaving = false
    correlative = undefined
    fiscalAlerts = {
        enabled: true,
        email: '',
        whatsAppNumber: '',
        telegramChatId: '',
    }
    saveMessage = null
    saveError = null

    constructor() {
        makeAutoObservable(this)
    }

    reset() {
        this.isLoading = true
        this.saveMessage = null
        this.saveError = null
    }

    async loadSettings() {
        this.isLoading = true
        this.saveError = null
        try {
            const fiscal = await apiService.Settings.getFiscalAlerts()
            runInAction(() => {
                this.fiscalAlerts = {
                    enabled: fiscal.Enabled ?? true,
                    email: fiscal.Email ?? '',
                    whatsAppNumber: fiscal.WhatsAppNumber ?? '',
                    telegramChatId: fiscal.TelegramChatId ?? '',
                }
                this.isLoading = false
            })
        } catch {
            runInAction(() => {
                this.saveError = 'error_loading_data'
                this.isLoading = false
            })
        }
    }

    setFiscalField(field, value) {
        this.fiscalAlerts[field] = value
    }

    async saveFiscalAlerts() {
        this.isSaving = true
        this.saveMessage = null
        this.saveError = null
        try {
            const payload = {
                Enabled: this.fiscalAlerts.enabled,
                Email: this.fiscalAlerts.email?.trim() || null,
                WhatsAppNumber: this.fiscalAlerts.whatsAppNumber?.trim() || null,
                TelegramChatId: this.fiscalAlerts.telegramChatId?.trim() || null,
            }
            const saved = await apiService.Settings.updateFiscalAlerts(payload)
            runInAction(() => {
                this.fiscalAlerts = {
                    enabled: saved.Enabled ?? true,
                    email: saved.Email ?? '',
                    whatsAppNumber: saved.WhatsAppNumber ?? '',
                    telegramChatId: saved.TelegramChatId ?? '',
                }
                this.saveMessage = 'saved_successfully'
                this.isSaving = false
            })
        } catch {
            runInAction(() => {
                this.saveError = 'error_saving_data'
                this.isSaving = false
            })
        }
    }
}

export default new SettingsStore();
